import axios from "axios"
import apiEndpoints from "../config/apiEndpoints"

export const getLanguageDetails=async(key)=>{
    try {
        const response =await axios.get(apiEndpoints.GET_LANGUAGE(key))
        return response; 
    } catch (error) {
        console.error("Error fetching language details", error?.message);
        return null;     
    }
}
export const fetchGenderType=async(key,lang)=>{
    try {
        const response =await axios.get(apiEndpoints.GET_GENDER_DETAILS(key,lang))
        return response; 
    } catch (error) {
        console.error("Error fetching language details", error?.message);
        return null;     
    }   
}

export const fetchTreatment=async(key,lang,idGender,widgetId)=>{
    try {
       
        const response =await axios.get(apiEndpoints.GET_TREATMENT(key,lang,idGender,widgetId))
        return response; 
    } catch (error) {
        console.error("Error fetching Treatment", error?.message);
        return null;     
    }   
}

export const fetchStylist=async(key,lang,idTreatment)=>{
    try {
        const response =await axios.get(apiEndpoints.GET_PROFEESIONALS(key,lang,idTreatment))
        return response; 
    } catch (error) {
        console.error("Error fetching Treatment", error?.message);
        return null;     
    }   
}

export const fetchAvailabilityDates=async(key,idProfessional,idTreatment,isNoPrefrence)=>{
    try {
       
        const response =await axios.get(apiEndpoints.GET_AVAILABILITY_DATE_PROFFESIONAL(key,idProfessional,idTreatment,isNoPrefrence))
        return response; 
    } catch (error) {
        console.error("Error fetching Availability date", error?.message);
        return null;     
    }   

}

export const fetchAvailabilityTime=async(key,idProfessional,idTreatment,date,isNoPrefrence)=>{
    try {
       
        const response =await axios.get(apiEndpoints. GET_AVAILABILITY_TIME_PROFESSIONAL(key,idProfessional,idTreatment,date,isNoPrefrence))
        return response; 
    } catch (error) {
        console.error("Error fetching Availability date", error?.message);
        return null;     
    }   
}
export const fetchUpsaleProducts=async(key,idTreatment)=>{
    try {
       
        const response =await axios.get(apiEndpoints. GET_UPSALE_PRODUCT_BY_TREATMENTBYID(key,idTreatment))
        return response; 
    } catch (error) {
        console.error("Error fetching Upsale products", error?.message);
        return null;     
    }   

}
export const fetchGuestDetails=async(key,lang)=>{
    try {
       
        const response =await axios.get(apiEndpoints.GET_GUEST_DETAILS_SALON(key,lang))
        return response; 
    } catch (error) {
        console.error("Error fetching Guest details", error?.message);
        return null;     
    }   

}
export const CreateSalonReservsation=async(palyoad)=>{
    try {
        const response = await axios.post(apiEndpoints.CREATE_RESERVATION_SALON,palyoad)
        return response?.data; 
    } catch (error) {
        console.error("Error in creating reservation", error?.message);
        return null;     
    }  
}
export const fetchWidgetSettings=async(key,lang,id,guestId=0)=>{
    try {
       
        const response =await axios.get(apiEndpoints.GET_WIDGET_SETTINGS_SALON(key,id,lang,guestId))
        return response; 
    } catch (error) {
        console.error("Error fetching Salon widget details", error?.message);
        return null;     
    }   

}
export const fetchAdditionalFields=async(id,lang,key)=>{
    try {
       
        const response =await axios.get(apiEndpoints.GET_SALON_FIELDS(id,lang,key))
        return response; 
    } catch (error) {
        console.error("Error fetching Salon fields details", error?.message);
        return null;     
    }   

}
export const transactionCostForReservationSalon=async(key,ID,lang)=>{
    try {
        const response = await axios.get(apiEndpoints.GET_TRANSACTIONCOST_SALON(key,ID,lang))
        return response; 
    } catch (error) {
        console.error("Error fetching extra product details", error?.message);
        return null;     
    }
}


